import { ChangeEvent } from 'react';
import FormGroup from '../../../../../components/FormGroup';
import Input from '../../../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { AsideContainer, Group, Container as StyledContainer } from '../styles';

interface CompanyAddressInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  isGettingCepData: boolean;
  cep: string;
  handleCepChange: (event: ChangeEvent<HTMLInputElement>) => void;
  uf: string;
  city: string;
  district: string;
  street: string;
  handleNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  number: string | number;
  handleComplementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  complement: string;
}

export default function CompanyAddress({
  getErrorMessageByFieldName,
  isGettingCepData,
  cep,
  handleCepChange,
  uf,
  city,
  district,
  street,
  handleNumberChange,
  number,
  handleComplementChange,
  complement,
}: CompanyAddressInterface) {
  return (
    <StyledContainer>
      <div className="card-title">
        Endereço da empresa
      </div>

      <AsideContainer>
        <Group>
          <FormGroup error={getErrorMessageByFieldName('cep')} isLoading={isGettingCepData}>
            <div className="title">CEP</div>
            <Input
              disabled={isGettingCepData}
              placeholder="Informe o CEP"
              value={cep}
              onChange={handleCepChange}
              autoComplete="new-password"
              maxLength={9}
              error={getErrorMessageByFieldName('cep')}
            />
          </FormGroup>
        </Group>
        <Group>
          <FormGroup isLoading={isGettingCepData}>
            <div className="title">UF</div>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={uf}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <FormGroup isLoading={isGettingCepData}>
            <div className="title">Cidade</div>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={city}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>

        <Group>
          <FormGroup isLoading={isGettingCepData}>
            <div className="title">Bairro</div>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={district}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>

        <Group>
          <FormGroup isLoading={isGettingCepData}>
            <div className="title">Logradouro</div>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={street}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <FormGroup error={getErrorMessageByFieldName('number')}>
            <div className="title">Número</div>
            <Input
              onChange={handleNumberChange}
              placeholder="Caso não tenha, preencha 0"
              value={number}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('number')}
            />
          </FormGroup>
        </Group>

        <Group>
          <FormGroup>
            <div className="title">Complemento</div>
            <Input
              onChange={handleComplementChange}
              placeholder="Complemento"
              value={complement}
              maxLength={20}
              autoComplete="new-password"
            />
          </FormGroup>
        </Group>
      </AsideContainer>
    </StyledContainer>
  );
}
